import { Injectable } from '@angular/core';
import { UserRepositoryModule } from './user.module';
import { HttpRequestBuilder } from '../../core';
import { OneHttpClientService } from '../public_api';
import { Observable } from 'rxjs';
import { CustomerPortalUser } from './models/user.model';

@Injectable({ providedIn: UserRepositoryModule })
export class UserRepository {
  public static readonly RESOURCE = {
    root: '/v1/users',
  };

  private _req = new HttpRequestBuilder(UserRepository.RESOURCE.root);

  constructor(private http: OneHttpClientService) {}

  getUser(): Observable<CustomerPortalUser> {
    const request = this._req.api().authenticated();

    return this.http.callObject<CustomerPortalUser>(request);
  }
}
